export const triggeredAction = 'TriggeredAction';
export const triggeredActionEvents = {
    LOGIN_FORM_SUBMITTED: 'LoginFormSubmitted',
    UNSUBSCRIBED: 'Unsubscribed',
    CLICKED_MENU_ITEM: 'ClickedMenuItem',
    SEARCHED: 'Searched',
    STREAM_PLAYED: 'StreamPlayed',
    STREAM_PAUSED: 'StreamPaused',
    STREAM_AUTOPLAYED: 'StreamAutoplayed',
    STREAM_VOLUME_CHANGED: 'StreamVolumeChanged',
    STREAM_FULL_SCREEN: 'StreamFullScreen',
    STREAM_QUALITY_CHANGED: 'StreamQualityChanged',
    STREAM_SEARCHED: 'StreamSearched',
    VIDEO_PLAYED: 'VideoPlayed',
    VIDEO_PAUSED: 'VideoPaused',
    VIDEO_AUTOPLAYED: 'VideoAutoplayed',
    VIDEO_VOLUME_CHANGED: 'VideoVolumeChanged',
    VIDEO_FULL_SCREEN: 'VideoFullScreen',
    VIDEO_QUALITY_CHANGED: 'VideoQualityChanged',
    VIDEO_SEARCHED: 'VideoSearched',
};
